import React from 'react';

export const UnknownRoute: React.VFC = () => {
  return <div></div>;
};
